export interface Project {
  id: string;
  title: string;
  client: string;
  description: string;
  longDescription?: string;
  technologies: string[];
  category: string;
  imageUrl: string;
  images?: string[];
  completedDate: string;
  featured: boolean;
}

export const projects: Project[] = [
  {
    id: '1',
    title: 'DynastyOwner',
    client: 'DynastyOwner',
    description: 'Dynasty Owner is the first year round, business oriented fantasy gaming experience. You own your teams, you pay salaries, and you build a Dynasty.',
    longDescription: 'Built the entire application from ground up for this revolutionary fantasy sports platform. Key features include live draft picks with real-time interaction between league players, player trading system using Dynasty Dollars (tied to real currency), comprehensive login and authentication systems, and live chat functionality during draft picks. The platform delivers a year-round fantasy gaming experience with business management elements.',
    technologies: ['Node.js', 'Angular', 'PostgreSQL', 'Socket.io', 'Redis'],
    category: 'Web Application',
    imageUrl: '/images/projects/dy6.png',
    images: [
      '/images/projects/dy1.jpg',
      '/images/projects/dy2.jpg',
      '/images/projects/dy3.jpg',
      '/images/projects/dy4.jpg',
      '/images/projects/dy5.jpg',
      '/images/projects/dy6.png'
    ],
    completedDate: '2024-08',
    featured: true
  },
  {
    id: '2',
    title: 'IndieFlow',
    client: 'IndieFlow',
    description: 'Music Management Tools. Made by Musicians. Manage projects. Schedule. Distribute and promote your music. Get paid. All in ONE place.',
    longDescription: 'Developed a comprehensive music management platform built by musicians, for musicians. IndieFlow provides an all-in-one solution where independent artists can manage projects, schedule releases, distribute and promote their music, and get paid—all from a single platform. Key features we developed include: (1) File management system similar to Google Drive for organizing all project-related files with folder hierarchy and standard file operations, (2) Playlist creator enabling users to upload tracks with automatic album theme detection based on album art, with options to publish playlists publicly or share privately via link with track-specific commenting functionality, (3) Track/album distribution system allowing official distribution to major platforms like Spotify and Apple Music with integrated payment processing, (4) Project and task manager for creating shared projects with built-in task management for team collaboration, and (5) Major backend overhaul including legacy code refactoring, monorepo implementation for centralized project management, introduction of Stencil.js with common component library (buttons, tables), and comprehensive theming system using Tailwind CSS.',
    technologies: ['Stencil.js', 'Angular', 'Node.js', 'Ruby on Rails', 'Monorepo', 'AWS', 'Flutter'],
    category: 'Web Application',
    imageUrl: '/images/projects/in1.jpg',
    images: [
      '/images/projects/in1.jpg',
      '/images/projects/in2.jpg',
      '/images/projects/in3.jpg',
      '/images/projects/in4.jpg',
      '/images/projects/in5.jpg',
      '/images/projects/in6.jpg',
      '/images/projects/in7.jpg',
      '/images/projects/in8.jpg',
      '/images/projects/in9.jpg',
      '/images/projects/in10.jpg'
    ],
    completedDate: 'Ongoing',
    featured: true
  },
  {
    id: '3',
    title: 'E-commerce Platform Development',
    client: 'RetailMax Inc.',
    description: 'Built a scalable e-commerce platform handling 10k+ daily transactions.',
    longDescription: 'Developed a high-performance e-commerce solution with advanced analytics, inventory management, and payment integration.',
    technologies: ['React', 'Python', 'PostgreSQL', 'Redis', 'Stripe API'],
    category: 'Web Development',
    imageUrl: '/images/projects/ecommerce-platform.jpg',
    images: [
      '/images/projects/ecommerce-1.jpg',
      '/images/projects/ecommerce-2.jpg'
    ],
    completedDate: '2024-06',
    featured: false
  },
  {
    id: '4',
    title: 'Business Intelligence Dashboard',
    client: 'DataDriven Analytics',
    description: 'Created an interactive BI dashboard for real-time business insights.',
    longDescription: 'Designed and implemented a comprehensive business intelligence solution that provides real-time analytics and predictive insights.',
    technologies: ['Vue.js', 'D3.js', 'Python', 'Apache Spark', 'MongoDB'],
    category: 'Data Analytics',
    imageUrl: '/images/projects/bi-dashboard.jpg',
    completedDate: '2024-04',
    featured: false
  }
];

export const clients: string[] = [
  'TechCorp Solutions',
  'RetailMax Inc.',
  'DataDriven Analytics',
  'InnovateLab',
  'GlobalTech Enterprises',
  'StartupAccelerator',
  'FinanceFirst Bank',
  'HealthcarePlus'
];

export const services = [
  {
    title: 'Digital Transformation',
    description: 'Modernize your business with cutting-edge technology solutions',
    icon: '🚀'
  },
  {
    title: 'Web Development',
    description: 'Custom web applications built with modern frameworks',
    icon: '💻'
  },
  {
    title: 'Data Analytics',
    description: 'Transform data into actionable business insights',
    icon: '📊'
  },
  {
    title: 'Cloud Solutions',
    description: 'Scalable cloud infrastructure and migration services',
    icon: '☁️'
  }
];